import React from "react";
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/system';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ManagerPic from '../assets/oliver.png'

import SharePointService from '../services/sharepoint.service';


export default function CustomerManager() {
    var customerManagerHTML = 
        <Grid container>
            <Grid item xs={12}><Paper elevation={1} >
                 <Box pt={3} px={3}>
                     <h2>Unser Team ist für Sie da.</h2>
                     <img src={ManagerPic} alt="Kundenmanager Oliver" style={{ width: '100%', height: 'auto', maxWidth: '200px' }} />
                 </Box>
                 <Box sx={{display: 'flex'}}>
                     <Box py={3} px={3}>
                         <h5>Oliver Scholl<br></br>Der-FINanzierer<br></br></h5>
                         <span>Tel: 01512 5810195</span><br></br>
                         <a href="mailto:oliver.scholl-pv@der-finanzierer.com">E-Mail schreiben</a>
                     </Box>
                 </Box>
             </Paper>      
             </Grid>
            
        </Grid>
    ;
    return( customerManagerHTML
        
    )
}